export enum ToastPosition {
  BOTTOM_CENTER = 'bottom-center',
  TOP_CENTER = 'top-center',
}
